<div class="buttons-container">
    <button
        type="button"
        class="btn btn-danger sume-btn-fixed-width btn-cancelar"
        (click)="onCancelar()">
        {{ textoCancelar }}
    </button>
    <button
        type="submit"
        class="btn btn-primary sume-btn-fixed-width btn-confirmar"
        [ngbTooltip]="disabledMessage || null"
        [disabled]="!canSubmit"
        (click)="$event.preventDefault(); onConfirmar()">
        {{ textoConfirmar }}
    </button>
</div>
